import SectionHead from './SectionHead';
import { latestFeed } from '../data';

export default function FeedSection() {
  const [featured, ...rest] = latestFeed;

  return (
    <section id="feed" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 md:px-6 py-10 md:py-16">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <SectionHead
          eyebrow="素材流 · 按时间新增"
          title="最新归档，先看新入库的素材"
          desc="每条素材都带编号与来源标注，新增按时间倒序推送，方便你跟踪事件推进的最新一手材料。"
        />
        <a
          href="#archive"
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 hover:bg-background-100"
        >
          进入完整素材库
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
        </a>
      </div>

      {/* 大卡 */}
      <article className="mt-6 flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 lg:flex-row">
        <div className="relative h-52 w-full shrink-0 lg:h-auto lg:w-[42%]">
          {featured.img && (
            <img
              src={featured.img}
              alt={featured.title}
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
          )}
          <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-600 px-3 py-1 text-xs font-semibold text-background-50">
            <i className="ri-pushpin-2-fill w-3 h-3 flex items-center justify-center" />
            置顶精选
          </span>
        </div>
        <div className="flex flex-1 flex-col justify-center p-5 md:p-7">
          <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-2.5 py-1 font-medium text-secondary-900">
              {featured.tag}
            </span>
            <span>{featured.time}</span>
          </div>
          <h3 className="mt-3 font-heading text-xl md:text-2xl font-bold leading-snug text-foreground-950">
            {featured.title}
          </h3>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">{featured.summary}</p>
          <div className="mt-5 flex flex-wrap items-center justify-between gap-3">
            <span className="inline-flex items-center gap-1.5 text-xs text-primary-700">
              <i className="ri-file-list-3-line w-3.5 h-3.5 flex items-center justify-center" />
              {featured.count}
            </span>
            <a
              href="#timeline"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-primary-700"
            >
              展开逐屏记录
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </a>
          </div>
        </div>
      </article>

      {/* 小卡网格 */}
      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
        {rest.map((item) => (
          <article
            key={item.id}
            className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-4 md:p-5"
          >
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-900">
                {item.tag}
              </span>
              <span className="text-[11px] text-foreground-500">{item.time}</span>
            </div>
            <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
              {item.title}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-[11px] font-medium text-secondary-700">
              <i className="ri-file-list-3-line w-3.5 h-3.5 flex items-center justify-center" />
              {item.count}
            </span>
          </article>
        ))}
      </div>
    </section>
  );
}